import { ElementRef, Injectable } from '@angular/core';

/**
 * Convienent methods that can be used in templates.  Inject as public service in constructor
 */
@Injectable()
export class TemplateUtilService {
  /**
   * returns true if an element has no child nodes.  Useful to detect if ngContent is populated
   * @param elem An ElementRef or any (which will be tested if it has childNodes)
   * @example ```
   * <ng-content #MyTemplate [hidden]="!templateUtil.elemIsEmpty(MyTemplate)"></ng-content>
   * ```
   */
  elemIsEmpty(elem: ElementRef | any) {
    if (elem) {
      const nodeList = (elem instanceof ElementRef && elem.nativeElement)
        ? (elem.nativeElement as HTMLElement).childNodes
        : elem.childNodes as (NodeListOf<ChildNode> | undefined);

      const nodes = nodeList ? Array.from(nodeList) : [];

      // return false if an elem node is detected or a non-comment node with textContent.
      return !nodes.some(x => x.nodeType === Node.ELEMENT_NODE || (x.nodeType !== Node.COMMENT_NODE && x.textContent?.trim().length));
    }

    return true;
  }
}
